import { APIContext } from "../../types";
import { makePath } from "../../../url";
import * as APITypes from "../../generated-types/v1/Api";
import { getJSON, postJSON } from "../../request";

export type CheckinSessionAPI = ReturnType<typeof createCheckinSessionAPI>;

export function createCheckinSessionAPI({ buildURL, fetchJSON }: APIContext) {
  function createSession({ seed }: { seed: string }) {
    const path = makePath(["api", "v1", "booking", "checkin-session"]);

    const payload: APITypes.CreateCheckinSessionRequest = {
      seed,
    };

    const url = buildURL(path);
    const request = postJSON(url, payload);

    return fetchJSON<APITypes.CheckinSessionState>(request);
  }

  function fetchSession({ sessionId }: { sessionId: string }) {
    const path = makePath([
      "api",
      "v1",
      "booking",
      "checkin-session",
      sessionId,
    ]);

    const url = buildURL(path);
    const request = getJSON(url);

    return fetchJSON<APITypes.CheckinSessionState>(request);
  }

  function joinSession({ sessionId }: { sessionId: string }) {
    const path = makePath([
      "api",
      "v1",
      "booking",
      "checkin-session",
      sessionId,
      "join",
    ]);

    const url = buildURL(path);
    const request = postJSON(url, {});

    return fetchJSON<APITypes.CheckinSessionState>(request);
  }

  function closeSession({ sessionId }: { sessionId: string }) {
    const path = makePath([
      "api",
      "v1",
      "booking",
      "checkin-session",
      sessionId,
      "close",
    ]);

    const url = buildURL(path);
    const request = postJSON(url, {});

    return fetchJSON<APITypes.CheckinSessionState>(request);
  }

  return { createSession, fetchSession, joinSession, closeSession };
}
